import store from '../state/store.js'
import {
  fetchUserVotingCategoryError,
  fetchUserVotingCategorySuccess
} from '../state/voting'

import { AuthorizedApi } from './index.js'

export function fetchUserVotingCategory (config, auth, category) {
  const api = new AuthorizedApi(
    config,
    (success) => {
      const { data } = success
      store.dispatch(fetchUserVotingCategorySuccess(data))
    },
    (error) => {
      store.dispatch(fetchUserVotingCategoryError(error))
    }
  )

  api.fetchWithToken(`voting/categories/${category}/user`, auth?.accessToken)
}

export function vote (config, auth, category, campaign, entity, data) {
  const api = new AuthorizedApi(
    config,
    (success) => {
      const { data } = success
      store.dispatch(fetchUserVotingCategorySuccess(data))
    },
    (error) => {
      store.dispatch(fetchUserVotingCategoryError(error))
    }
  )

  api.postWithToken(`voting/categories/${category}/${campaign}/${entity}`, auth?.accessToken, data)
}

export function cancelVote (config, auth, category, campaign, entity) {
  const api = new AuthorizedApi(
    config,
    (success) => {
      const { data } = success
      store.dispatch(fetchUserVotingCategorySuccess(data))
    },
    (error) => {
      store.dispatch(fetchUserVotingCategoryError(error))
    }
  )

  api.deleteWithToken(`voting/categories/${category}/${campaign}/${entity}`, auth?.accessToken)
}
